<template>
  <!-- 订单支付列表页 -->
  <div>
    <a-card title="订单支付" style="margin: 20px">
      <!-- 头部筛选区域 -->
      <div class="selected-box">
        <div class="selected-box-item">
          <span class="left-item">机构</span>
          <DepartmentChoose :department-code.sync="searchFrom.departmentCode" @change="handleQuery"></DepartmentChoose>
        </div>
        <div class="selected-box-item">
          <span class="left-item">订单时间</span>
          <a-range-picker v-model.trim="selectedRange" valueFormat="YYYY-MM-DD"/>
        </div>

        <div class="selected-box-item">
          <span class="left-item">状态</span>
          <a-select v-model="searchFrom.status" @change="handleQuery" allow-clear>
            <a-select-option v-for="(type, value) in commonDict.guaranteeStatusConfig" :key="value" :value="value">
              <a-tag v-if="type.show" :color="type.color">{{ type.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>

        <div class="selected-box-item">
          <span class="left-item">档案编号</span>
          <a-input v-model.trim="searchFrom.archiveNo" placeholder="请输入档案编号"></a-input>
        </div>

        <div class="selected-box-item">
          <span class="left-item">订单编号</span>
          <a-input v-model.trim="searchFrom.orderNo" placeholder="请输入订单编号"></a-input>
        </div>

        <div class="selected-box-item">
          <span class="left-item">客户名称</span>
          <a-input v-model.trim="searchFrom.accountName" placeholder="请输入客户名称"></a-input>
        </div>
        <div class="selected-box-item">
          <span class="left-item">客户证件号</span>
          <a-input v-model.trim="searchFrom.certNo" placeholder="请输入客户证件号"></a-input>
        </div>
        <div class="selected-box-item" style="display: block">
          <a-button type="primary" icon="search" @click="handleQuery">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </div>
      </div>
      <!-- 表格区域 -->
      <div class="table-box">
        <div class="table-box-handle">
          <a-button type="primary" @click="add" v-if="$authority('cert_add')">登记</a-button>
        </div>
        <div class="table-main">
          <a-table size="small"
                   :scroll="{ x: 1200, }"
                   :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :customRow="clickrow" :columns="columns" :data-source="listData" :pagination="false"
                   :rowKey="(record, index) => `${record.id}`">
            <template slot="detail" slot-scope="text, record">
              <a-button type="link" @click="details(record)" v-if=" $authority('cert_details')">
                <a-icon type="bars"/> {{text}}
              </a-button>
              <template v-else>
                {{text}}
              </template>
            </template>
            <template slot="operation1" slot-scope="text, record">
              <a-space size="small">
                <a-button-group size="">
                  <a-button type="link" size='small' style="color: red" v-if="record.status === 0 && $authority('cert_del')" @click="invalid(record)">
                    <a-icon type="delete"/>
                  </a-button>
                  <a-button type="link" size='small' style="color: #34C759" @click="copy(record)">
                    <a-icon type="copy"/>
                  </a-button>
                </a-button-group>
              </a-space>
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-space size="small">
                <a-button-group size="">
                  <a-button type="primary" v-if="record.status === 0 && $authority('cert_bailInsure') " :disabled="record.balance<record.amount"
                            @click="bailInsureShow(record)">
                    <a-icon type="lock"/>
                    冻结
                  </a-button>
                  <a-button type="danger" v-if="(record.status === 1 || record.status === 3) && $authority('cert_bailRepay')" @click="bailRepay(record)">
                    <a-icon type="unlock"/>
                    {{ record.status === 1 ? '退还' : '提现' }}
                  </a-button>
                  <a-button type="primary" v-if="record.status === 1 && $authority('cert_complete')" @click="complete(record)">
                    完成
                  </a-button>
                </a-button-group>
              </a-space>
            </template>
            <template v-slot:balance="text, record">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <balance  :amount="Number(record.balance)" :dcflag="record.balance < record.amount? 'c':'d'"/>
<!--                <span v-if="record.balance>=record.amount" style="margin-top: 5px; text-align: center;"><balance  :amount="Number(record.balance)" /></span>-->
<!--                <span v-else style="margin-top: 5px; text-align: center; color: red">余额不足</span>-->
              </div>
            </template>
          </a-table>
        </div>
      </div>
      <lcfs-pagination :page-no.sync="searchFrom.pageNo" :page-size.sync="searchFrom.pageSize" :total="total"
                       :fn="getPageList"></lcfs-pagination>
    </a-card>
    <a-modal v-model="addVisible" title="新增鉴证订单" @ok="handleAddOk" @cancel="handleAddCancel">
      <a-form-model ref="addFormRef" :model="addForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" :rules="addRules">
        <!-- 基础信息 -->
        <a-form-model-item label="客户账号" name="accountName" prop="accountName">
          <WalletChooseDialog v-model="addForm.accountName" :custname="addForm.custname" :account-class="'0'"
                              @chooseDone="onWalletChosen"/>
        </a-form-model-item>

        <a-form-model-item label="订单金额" name="amount" prop="amount">
          <a-input-number v-model="addForm.amount" placeholder="请输入订单金额" style="width: 100%"/>
        </a-form-model-item>

        <a-form-model-item label="收款账号" name="collectAccName" prop="collectAccName">
          <WalletChooseDialog v-model="addForm.collectAccName" :custname="addForm.collectAccName" :account-class="'0'"
                              @chooseDone="onWalletCollectChosen"/>
        </a-form-model-item>

        <a-form-model-item label="档案编号" prop="archiveNo">
          <a-input v-model="addForm.archiveNo" placeholder="请输入档案编号"/>
        </a-form-model-item>

        <a-form-model-item label="上传凭证">
          <a-upload
              name="addFile"
              :multiple="false"
              :accept="'.pdf,.png,.jpg,.jpeg,'"
              :beforeUpload="beforeUpload"
              :file-list="addForm.fileList"
              @change="handleAddFileChange"
              :customRequest="() => {}"
          >
            <a-button>
              <a-icon type="upload"/>
              选择文件
            </a-button>
          </a-upload>
        </a-form-model-item>

        <!-- 服务费信息 -->
        <a-card title="手续费信息" style="margin-bottom: 20px;">
          <a-form-model-item label="扣款账户" prop="fee.payerAccName" name="fee.payerAccName">
            <WalletChooseDialog v-model="addForm.fee.payerAccName" :custname="addForm.fee.payerAccName" :account-class="'0'"
                                @chooseDone="onWalletPayerChosen"/>
          </a-form-model-item>

          <a-form-model-item label="收费账户" prop="fee.collectAccName" name="fee.collectAccName">
            <WalletChooseDialog v-model="addForm.fee.collectAccName" :custname="addForm.fee.collectAccName" :account-class="'0'"
                                @chooseDone="onFeeWalletCollectChosen"/>
          </a-form-model-item>

          <a-form-model-item label="服务费规则" prop="fee.feeNo" name="fee.feeNo">
            <a-select v-model="addForm.fee.feeNo" placeholder="请选择服务费规则" @change="handleFeeRuleChange">
              <a-select-option v-for="item in feeRuleList" :key="item.id" :value="item.feeNo">
                {{ item.feeName }}
              </a-select-option>
            </a-select>

          </a-form-model-item>
        </a-card>

      </a-form-model>
    </a-modal>


    <a-modal v-model="editVisible" title="凭证上传" @ok="handleUploadOk" @cancel="handleCancel">
      <a-form-model ref="editFormRef" :model="uploadForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="档案编号" prop="archiveNo">
          <a-input v-model="uploadForm.archiveNo" placeholder="请输入档案编号"/>
        </a-form-model-item>

        <a-form-model-item label="上传凭证" prop="file">
          <a-upload
              name="editFile"
              :multiple="false"
              :accept="'.pdf,.png,.jpg,.jpeg,'"
              :beforeUpload="beforeUpload"
              :file-list="uploadForm.fileList"
              @change="handleFileChange"
              :customRequest="() => {}"
          >
            <a-button>
              <a-icon type="upload"/>
              选择文件
            </a-button>
          </a-upload>

        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="bailRepayVisible" title="冻结资金待确认" @ok="bailInsureOk" @cancel="bailInsureCancel">
      <a-form-model ref="bailFormRef" :model="bailForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="订单编号" prop="orderNo">
          <a-input v-model="bailForm.orderNo"  :disabled="true"/>
        </a-form-model-item>
        <a-form-model-item label="冻结账户" prop="accountName">
          <Wallet-info :account-no="bailForm.accountNo" :account-name="bailForm.accountName" :enable-query-balance="true"/>
        </a-form-model-item>
        <a-form-model-item label="金额" prop="amount">
          <a-input-number v-model="bailForm.amount" :min="0" :formatter="value => `￥${value}`" placeholder="请输入冻结金额"
                          style="width: 100%"/>
        </a-form-model-item>

      </a-form-model>
    </a-modal>

    <a-modal v-model="detailVisible" title="订单详情" @ok="handleDetail" @cancel="handleDetail" :width="'80vh'">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="基础信息">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="订单号" :span="3">{{ detailData.orderNo }}</a-descriptions-item>

            <a-descriptions-item label="客户名称" :span="1">{{ detailData.accountName }}</a-descriptions-item>
            <a-descriptions-item label="证件号码" :span="2">{{ detailData.certNo }}</a-descriptions-item>

            <a-descriptions-item label="A1账户" :span="1">{{ detailData.accountNo }}</a-descriptions-item>
            <a-descriptions-item label="A6账户" :span="2">{{ detailData.accountNoA6 }}</a-descriptions-item>

            <a-descriptions-item label="收款账户" :span="1">{{ detailData.collectAccName }}</a-descriptions-item>
            <a-descriptions-item label="收款账号" :span="2">{{ detailData.collectAcc }}</a-descriptions-item>

            <a-descriptions-item label="档案编号" :span="1">{{ detailData.archiveNo }}</a-descriptions-item>
            <a-descriptions-item label="凭证" :span="2">
              <a v-if="detailData.archiveFileUrl" :href="detailData.archiveFileUrl" target="_blank">查看文件</a>
              <span v-else>无凭证</span>
            </a-descriptions-item>


            <a-descriptions-item label="订单金额" :span="3">{{ detailData.amount }}</a-descriptions-item>
            <a-descriptions-item label="状态" :span="3">
              <a-tag :color="getStatusColor(detailData.status)">
                {{ getStatusLabel(detailData.status) }}
              </a-tag>
            </a-descriptions-item>

            <a-descriptions-item label="冻结时间" :span="3" v-if="detailData.status==1  && detailData.payTime">{{ formatDateTime(detailData.payTime) }}</a-descriptions-item>
            <a-descriptions-item label="退款时间" :span="3" v-if="detailData.status==3  && detailData.refundTime">{{ formatDateTime(detailData.refundTime) }}</a-descriptions-item>
            <a-descriptions-item label="完成时间" :span="3" v-if="detailData.status==2  && detailData.completeTime">{{ formatDateTime(detailData.completeTime) }}</a-descriptions-item>
          </a-descriptions>
        </a-collapse-panel>

        <a-collapse-panel key="2" header="服务费" v-if="$authority('cert_fee')" :disabled="false">
          <a-descriptions bordered :column="2" size="small">


            <a-descriptions-item label="扣款账户" :span="1">{{ detailData.fee.payerAccName }}</a-descriptions-item>
            <a-descriptions-item label="扣款账号" :span="2">{{ detailData.fee.payerAcc }}</a-descriptions-item>

            <a-descriptions-item label="收款账户" :span="1">{{ detailData.fee.collectAccName }}</a-descriptions-item>
            <a-descriptions-item label="收款账号" :span="2">{{ detailData.fee.collectAcc }}</a-descriptions-item>

            <a-descriptions-item label="金额" :span="3">￥  {{ detailData.fee.amount }}</a-descriptions-item>
            <a-descriptions-item label="状态" :span="3">
              <a-space>
                <a-tag :color="getFeetatusColor(detailData.fee.status)">
                  {{ getFeeStatusLabel(detailData.fee.status) }}
                </a-tag>
                <a-button v-if="(detailData.fee.status===0 || detailData.fee.status === 2)&&(detailData.status===1 || detailData.status===2)" @click="payCommission(detailData)" type="link">重试</a-button>
              </a-space>

            </a-descriptions-item>

            <a-descriptions-item label="项目名称" :span="3">{{ detailData.fee.ruleName }}</a-descriptions-item>
            <a-descriptions-item label="项目编号" :span="3">{{ detailData.fee.ruleNo }}</a-descriptions-item>
          </a-descriptions>
        </a-collapse-panel>

      </a-collapse>


    </a-modal>


  </div>
</template>

<script>
import Balance from '@/view/components/Balance.vue'
import WalletInfo from '@/view/components/WalletInfo.vue'
import OrderStatus from "@/view/Orders/PaymentOrders/components/OrderStatus.vue"
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import DeptInfo from "@/view/components/DeptInfo.vue";
import {commonDict} from "@/utils/bizDict/commonDict.js";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WithdrawBtn from "@/view/components/WithdrawBtn.vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import dayjs from "dayjs";

export default {
  name: 'certOrder',
  props: {},
  components: {
    LcfsPagination,
    WithdrawBtn, WalletChooseDialog, DepartmentChoose, Balance, WalletInfo, OrderStatus, DeptInfo},
  data() {
    return {
      activeKey: ['1'],
      commonDict,
      // 机构数据
      treeData: [],
      institutiontrees: {},
      // 绑定时间范围
      selectedRange: [],
      // 表格数据
      listData: [],
      columns: [
        {
          title: 'No',
          customRender: (text, record, index) =>
              `${Number(this.searchFrom.pageNo - 1) *
              Number(this.searchFrom.pageSize) +
              Number(index + 1)
              }`,
          align: 'center',
          fixed: 'left',
          key: 'sort',
          width: 80,
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          fixed: 'left',
          key: 'status',
          width: 150,
          customRender: (text) => {
            const taskStatus = commonDict.guaranteeStatusConfig[text] || commonDict.taskStatusConfig.default;
            return <a-tag color={taskStatus.color}>{taskStatus.label}</a-tag>
          }
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          align: 'center',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'detail' }
        },
        {
          title: '档案编号',
          dataIndex: 'archiveNo',
          key: 'archiveNo',
          align: 'center',
          width: 120,
          ellipsis: true,
          customRender: (text, record) => {
            if (!text) {
              // 档案编号为空时显示上传按钮
              return (
                  <a-button type="link" size="small" onClick={() => this.archiveUpload(record)}>
                    <a-icon type="upload"/>
                  </a-button>
              );
            } else {
              // 档案编号非空时根据状态判断是否显示编辑按钮
              if (record.status == 0 && this.$authority('cert_archiveUpload')) {
                return (
                    <span>
                      <a-button type="link" size='small' onClick={() => this.archiveUpload(record)}>
                        {text}
                      </a-button>
                    </span>
                );
              }
              return text; // 状态不允许或无权限，只显示文本
            }
          }
        },

        {
          title: '客户',
          dataIndex: 'accountNo',
          key: 'accountNo',
          align: 'center',
          width: 140,
          customRender: (text, row) => {
            if (!text) {
              return ""
            }
            return <WalletInfo showAccountName={true} showAccountNo={false} accountNo={row.accountNo} accountName={row.accountName} accountClass="1" showBalance={true}></WalletInfo>
          },
        },
        {
          title: '订单金额',
          dataIndex: 'amount',
          align: 'center',
          width: 200,
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },
        {
          title: '钱包余额',
          dataIndex: 'balance',
          key: 'balance',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'balance' }
        },
        {
          title: '机构',
          dataIndex: 'departmentCode',
          key: 'departmentCode',
          width: 100,
          align: 'center',
          ellipsis: true,
          customRender: (text) => {
            return <DeptInfo dept-code={text}></DeptInfo>
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          align: 'right',
          scopedSlots: {customRender: 'operation'},
          width: 140,
        },
        {
          title: '',
          dataIndex: 'operation1',
          fixed: 'right',
          align: 'center',
          scopedSlots: {customRender: 'operation1'},
          width: 100,
        },
      ],
      selectedRowKeys: [],
      // 筛选参数
      searchFrom: {
        pageNo: 1,
        pageSize: 10,

        departmentCode: '',
        ids: [],
        channelNo: '',
        appNo: '',
        orderNo: '',
        certNo: '',
        archiveNo: '',
        accountName: '',
        accountNo: '',
        // 开始时间
        startTime: '',
        // 结束时间
        endTime: '',
        // 下单状态
        status: undefined
      },
      // 总数
      total: 0,
      //分页大小
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      selectCustData: [],
      // 当前row
      currentRowKey: null,
      editVisible: false,
      uploadForm: {
        archiveNo: '',
        file: null,
        fileList: [],
      },
      currentRecord: null, // 当前选中的记录
      feeRuleList: [],
      addVisible: false,
      addForm: {
        channelNo: '',
        appNo: '',
        certNo: '',
        accountName: '',
        accountNo: '',
        accountNoA6: '',
        collectAcc: '',
        collectAccName: '',
        amount: null,
        departmentId: null,
        departmentCode: '',
        fee: {
          payerAcc: '',
          payerAccName: '',
          collectAcc: '',
          collectAccName: '',
          ruleName: '',
          ruleNo: ''
        },
        fileList: []
      },
      addRules: {
        accountName: [
          {required: true, message: '请选择客户账号', trigger: 'change'}
        ],
        collectAccName: [
          {required: true, message: '请选择收款账号', trigger: 'change'}
        ],
        // amount: [
        //   {required: true, message: '请输入订单金额', trigger: 'blur'},
        //   {type: 'number', min: 0.01, message: '金额必须大于0', trigger: 'blur'}
        // ],
        'fee.payerAccName': [
          {required: true, message: '请选择扣款账户', trigger: 'change'}
        ],
        'fee.collectAccName': [
          {required: true, message: '请选择收费账户', trigger: 'change'}
        ],
        'fee.feeNo': [
          {required: true, message: '请选择服务费规则', trigger: 'change'}
        ]
      },
      detailData: {
        channelNo: '',
        appNo: '',
        certNo: '',
        accountName: '',
        accountNo: '',
        accountNoA6: '',
        collectAcc: '',
        collectAccName: '',
        amount: null,
        departmentId: null,
        departmentCode: '',
        archiveFileUrl: '',
        fee: {
          payerAcc: '',
          payerAccName: '',
          collectAcc: '',
          collectAccName: '',
          ruleName: '',
          ruleNo: ''
        },
      },
      detailVisible: false,


      bailRepayVisible: false,
      bailForm: {
        orderNo: '',
        accountName: '',
        accountNo: '',
        amount: null,

      },


    }
  },
  computed: {},
  watch: {},
  created() {
    this.bailRepayVisible = false
    this.addVisible = false;
    this.editVisible = false;
    this.getPageList(); // 确保无论如何都加载数据
    this.getFeeRule(); // 确保无论如何都加载数据
  },

  methods: {
    formatDateTime(time) {
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    findItemById(dataObj, idToFind) {
      // 基本情况：如果当前数据对象具有匹配的ID，返回其名称
      if (dataObj.coreDepartment?.id === idToFind) {
        return dataObj.coreDepartment.name
      }
      // 递归情况：在子数组中搜索
      else if (dataObj.children && dataObj.children.length > 0) {
        for (const child of dataObj.children) {
          const foundName = this.findItemById(child, idToFind)
          if (foundName) {
            return foundName
            // 如果在子节点中找到，则返回名称
          }
        }
      }
      // 如果在数据对象中未找到匹配的ID，则返回null
      return null
    },
    // 获取列表函数
    async getPageList() {
      if (this.selectedRange.length != 0) {
        this.searchFrom.startTime = this.selectedRange[0] + " 00:00:00"
        this.searchFrom.endTime = this.selectedRange[1] + " 23:59:59"
      }
      let data = JSON.parse(JSON.stringify(this.searchFrom))
      let res = await this.api.certOrderPageApi(data)
      if (res.code == 200) {
        this.listData = res.data.records
        this.searchFrom.pageNo = res.data.current
        this.searchFrom.pageSize = res.data.size
        this.total = res.data.total
      } else {
        this.$message.error(res.info)
      }
    },
    // 查询
    handleQuery() {
      this.selectedRowKeys = []
      this.searchFrom.pageNo = 1
      this.getPageList()
    },
    // 重置
    handleReset() {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        // 机构ID
        departmentCode: '',
        // 订单类型
        orderType: '',
        // 支付方式
        payWay: '',
        // 电商名称
        mchName: '',
        // 电商编号
        mchNo: '',
        // 开始时间
        startTime: '',
        // 结束时间
        endTime: '',
        // 下单状态
        status: undefined
      }
      this.selectedRange = []
      this.getPageList()
    },
    onShowSizeChange(current, pageSize) {
      this.searchFrom.pageNo = current
      this.searchFrom.pageSize = pageSize
      this.getPageList()
    },

    // 修改上一页和下一页为文字链接
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a>上一页</a>
      } else if (type === 'next') {
        return <a>下一页</a>
      }
      return originalElement
    },
    // 选中行的回调
    onSelectChange(val, row) {
      this.selectedRowKeys = val
      this.selectCustData = row
    },
    clickrow(record) {
      return {
        on: {
          click: () => {
            let id = record.id.toString()
            let index = this.selectedRowKeys.findIndex((item) => id == item)
            if (index == -1) {
              this.selectedRowKeys.push(id)
              this.selectCustData.push(record)
            } else {

              this.selectedRowKeys.splice(index, 1)
              this.selectCustData.splice(index, 1)
            }
          }
        }
      }
    },


    // 去下单
    async toOrder(orderNo) {
      let res = await this.api.orderSyncApi(orderNo)
      if (res.code === 200) {
        this.$message.success(res.info)
        // 获取列表
        this.getPageList()
        this.selectCustData = []
        this.selectedRowKeys = []
      } else {
        this.$message.error(res.info)
      }
    },

    async details(record) {
      console.log('details', record)
      this.api.certOrderDetailApi(record).then(res => {
        if (res.code === 200) {
          this.detailVisible = true
          this.detailData = res.data
        } else {
          this.$message.error(res.info)
        }
      })
    },
    handleDetail() {
      this.detailVisible = false;
    },

    getStatusColor(status) {
      const taskStatus = commonDict.guaranteeStatusConfig[status] || commonDict.guaranteeStatusConfig.default;
      return taskStatus?.color || 'default';
    },
    // 获取状态标签
    getStatusLabel(status) {
      const taskStatus = commonDict.guaranteeStatusConfig[status] || commonDict.guaranteeStatusConfig.default;
      return taskStatus?.label || '未知状态';
    },
    getFeetatusColor(status) {
      const taskStatus = commonDict.certOrderFeeStatusConfig[status] || commonDict.certOrderFeeStatusConfig.default;
      return taskStatus?.color || 'default';
    },
    // 获取状态标签
    getFeeStatusLabel(status) {
      const taskStatus = commonDict.certOrderFeeStatusConfig[status] || commonDict.certOrderFeeStatusConfig.default;
      return taskStatus?.label || '未知状态';
    },

    async bailRepay(record) {
      const accountName = record.accountName || '未知账户';
      const isValidAmount = record.amount !== null && record.amount !== undefined;
      const amount = isValidAmount ? `￥ ${record.amount} 元` : '未知金额';
      const operation = record.status === 1 ? '退还' : (record.status === 2 ? '提现' : '操作');

      const self = this; // ✅ 缓存 this

      this.$confirm({
        title: `确定要${operation}该账户的保证金吗？`,
        content: `账户名称：${accountName}，金额：${amount}。\n\n⚠️ 注意：该操作不可回退，请确认操作无误！`,
        async onOk() {
          try {
            const res = await self.api.certOrderBailRepayApi(record); // ✅ 使用 self.api
            if (res.code === 200) {
              self.$message.success(`${accountName} 的保证金已成功${operation}`);
              self.getPageList();
            } else {
              self.$message.error(res.info || `${operation}失败，请稍后再试`);
            }
          } catch (err) {
            console.error('保证金操作异常：', err);
            self.$message.error(`${operation}请求异常，请稍后再试`);
          }
        },
        onCancel() {
          console.log('已取消保证金操作');
        }
      });
    },

    async payCommission(record) {
      this.$confirm({
        title: `确定要收取技术服务费吗？`,
        // content: `账户名称: 【${record.fee.payerAccName}】 , 金额: 【￥ ${record.fee.amount}】`,
        onOk: () => {
          this.api.certOrderPayCommissionApi(record).then(res => {
            if (res.code == 200) {
              this.$message.success('技术服务费收取成功')
              this.getPageList()
            } else {
              this.$message.error(res.info || '技术服务费失败，请稍后再试')
            }
          })
        },
        onCancel() {
          console.log('取消操作')
        }
      })
    },

    bailInsureShow(record) {
      this.bailForm.amount = record.amount > 0 ? record.amount : record.balance
      this.bailForm.orderNo = record.orderNo
      this.bailForm.accountName = record.accountName
      this.bailForm.accountNo = record.accountNo
      this.bailRepayVisible = true

    },

    async bailInsureOk() {
      const accountName = this.bailForm.accountName || '未知账户';
      const amount = this.bailForm.amount ? `￥ ${this.bailForm.amount} 元` : '未知金额';

      this.$confirm({
        title: `确定要收缴并冻结 ${accountName} 的保证金吗？`,
        content: `账户名称: 【${accountName}】 , 金额: 【${amount}】`,
        onOk: () => {
          this.api.certOrderBailInsureApi(this.bailForm).then(res => {
            if (res.code == 200) {
              this.$message.success('保证金已冻结，请及时更新档案编号')
              this.bailRepayVisible = false
              this.getPageList()
            } else {
              this.$message.error(res.info || '保证金冻结失败，请稍后再试')
            }
          })
        },
        onCancel() {
          console.log('取消缴纳')
        }
      })
    },
    async bailInsureCancel() {
      this.bailForm = {
        orderNo: '',
        accountName: '',
        accountNo: '',
        amount: null,
      }
    },
    async invalid(record) {
      this.$confirm({
        title: '确定要作废吗？',
        content: '作废后无法恢复，操作不可撤回。',
        onOk: () => {
          this.api.certOrderInvalidApi([record.orderNo]).then(res => {
            if (res.code === 200) {
              this.$message.success('已作废');
              this.getPageList();
            } else {
              this.$message.error(res.info || '作废失败，请稍后再试');
            }
          }).catch(error => {
            this.$message.error('作废操作出现错误，请稍后重试');
            console.error(error);
          });
        },
        onCancel() {
          console.log('用户取消了删除操作');
        }
      });
    },
    async copy(record) {
      this.$confirm({
        title: '确定要复制吗？',
        onOk: () => {
          this.api.certOrderCopyApi(record).then(res => {
            if (res.code === 200) {
              this.$message.success('复制成功');
              this.getPageList();
            } else {
              this.$message.error(res.info || '复制失败，请稍后再试');
            }
          }).catch(error => {
            this.$message.error('复制作出现错误，请稍后重试');
            console.error(error);
          });
        },
        onCancel() {
          console.log('用户取消了复制操作');
        }
      });
    },

    async complete(record) {
      this.$confirm({
        title: '确定要完成吗？',
        content: '完成后无法恢复，操作不可撤回。',
        onOk: () => {
          this.api.certOrderCompleteApi(record).then(res => {
            if (res.code === 200) {
              this.$message.success('完成成功');
              this.getPageList();
            } else {
              this.$message.error(res.info || '完成失败，请稍后再试');
            }
          }).catch(error => {
            this.$message.error('完成操作出现错误，请稍后重试');
            console.error(error);
          });
        },
        onCancel() {
          console.log('用户取消了完成操作');
        }
      });
    },
    async add() {
      this.addVisible = true
    },
    async getFeeRule() {
      let data = {};
      let res = await this.api.getCommisionFeeRuleApi(data);
      if (res.code == 200) {
        this.feeRuleList = res.data;
        this.feePayRuleList = res.data.filter(item => item.feeType !== '4');
        console.log(this.feePayRuleList, "feePayRuleList")
      }
    },
    async onWalletChosen(wallet) {
      console.log(wallet, 'onWalletChosen wallet');
      this.addForm.certNo = wallet.certnum
      this.addForm.accountNo = wallet.accountNo
      this.addForm.accountName = wallet.accountName
      this.addForm.appNo = wallet.appNo
      this.addForm.channelNo = wallet.channelNo
      this.addForm.departmentId = wallet.departmentId
      this.addForm.departmentCode = wallet.departmentCode
    },
    async onWalletCollectChosen(wallet) {
      console.log(wallet, 'onWalletCollectChosen wallet');
      this.addForm.collectAcc = wallet.accountNo
      this.addForm.collectAccName = wallet.accountName

    },


    async onWalletPayerChosen(wallet) {
      console.log(wallet, 'onWalletPayerChosen wallet');
      this.addForm.fee.payerAcc = wallet.accountNo
      this.addForm.fee.payerAccName = wallet.accountName

    },


    async onFeeWalletCollectChosen(wallet) {
      console.log(wallet, 'onFeeWalletCollectChosen wallet');
      this.addForm.fee.collectAcc = wallet.accountNo
      this.addForm.fee.collectAccName = wallet.accountName
    },

    async archiveUpload(record) {
      this.currentRecord = record;
      this.uploadForm.archiveNo = record.archiveNo || '';
      this.editVisible = true;
    },

    async handleUploadOk() {
      const {archiveNo,} = this.uploadForm;

      if (!archiveNo) {
        this.$message.warning('请填写档案编号');
        return;
      }


      const formData = new FormData();
      // 如果有文件，则添加到 formData
      if (this.uploadForm.fileList.length > 0) {
        const file = this.uploadForm.fileList[0].originFileObj;
        formData.append('file', file);
      }


      formData.append('archiveNo', this.uploadForm.archiveNo);
      formData.append('orderNo', this.currentRecord.orderNo); // 可选参数

      try {
        const res = await this.api.uploadArchiveAndFile(formData);
        if (res.code === 200) {
          this.$message.success('上传成功');
          this.editVisible = false;
          this.handleCancel();
          this.getPageList(); // 刷新表格
        } else {
          this.$message.error(res.info || '上传失败');
        }
      } catch (err) {
        this.$message.error('网络错误，请重试');
      }
    },


    handleFileChange(info) {
      console.log('handleFileChange', info)

      let fileList = [...info.fileList];
      fileList = fileList.slice(-1); // 只保留最后一个文件
      this.uploadForm.fileList = fileList;

      console.log('Selected File:', this.uploadForm.file);
    },


    beforeUpload(file) {
      const isValidSize = file.size / 1024 / 1024 < 10; // 限制文件大小为 5MB

      if (!isValidSize) {
        this.$message.error('文件大小不能超过 10MB');
      }

      return false;
    },
    handleCancel() {
      this.editVisible = false;
      this.uploadForm = {
        archiveNo: '',
        file: null,
        fileList: []
      };
    },

    handleAddFileChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1); // 只保留最后一个文件
      this.addForm.fileList = fileList;
    },

    handleFeeRuleChange(value) {
      const selectedRule = this.feeRuleList.find(item => item.feeNo === value);
      if (selectedRule) {
        this.addForm.fee.ruleName = selectedRule.feeName; // 设置 ruleName
        this.addForm.fee.ruleNo = selectedRule.feeNo;     // 可选：设置 ruleNo
      }
    },

    async handleAddOk() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          console.log("valid", valid)
          const formData = new FormData();

          const request = {
            channelNo: this.addForm.channelNo,
            appNo: this.addForm.appNo,
            certNo: this.addForm.certNo,
            accountName: this.addForm.accountName,
            accountNo: this.addForm.accountNo,
            amount: this.addForm.amount,
            departmentId: this.addForm.departmentId,
            departmentCode: this.addForm.departmentCode,
            collectAcc: this.addForm.collectAcc,
            collectAccName: this.addForm.collectAccName,
            fee: {
              payerAcc: this.addForm.fee.payerAcc,
              payerAccName: this.addForm.fee.payerAccName,
              collectAcc: this.addForm.fee.collectAcc,
              collectAccName: this.addForm.fee.collectAccName,
              ruleName: this.addForm.fee.ruleName,
              ruleNo: this.addForm.fee.ruleNo,
            }
          };


          // 如果有文件，则添加到 formData
          if (this.addForm.fileList.length > 0) {
            const file = this.addForm.fileList[0].originFileObj;
            formData.append('file', file);
          }

          // 添加 entity 数据
          formData.append('entity', JSON.stringify(request));

          // 发起请求
          const res = await this.api.certOrderAddApi(formData);
          if (res.code === 200) {
            this.$message.success('新增成功');
            this.handleAddCancel();
            this.getPageList();
          } else {
            console.log(res.info, 'res.info');
            this.$message.error(res.info || '新增失败');
          }
        }
      });

    },


    handleAddCancel() {
      this.addVisible = false;
      this.addForm = {
        certNo: '',
        accountName: '',
        accountNo: '',
        accountNoA6: '',
        collectAcc: '',
        collectAccName: '',
        amount: null,
        departmentCode: '',
        archiveFileUrl: '',
        fee: {
          amount: null,
          payerAcc: '',
          collectAcc: '',
          projNo: ''
        },
        fileList: []
      };
    },
    isImageUrl(url) {
      return url && /\.(jpe?g|png|gif)$/i.test(url);
    }



  }


}
</script>

<style lang="less" scoped>
.selected-box {
  display: flex;
  flex-wrap: wrap;

  /deep/ .selected-box-item {
    margin: 0 20px 20px 0;
    width: 280px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-item {
      margin-right: 15px;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select-selection--single {
      width: 200px;
    }
  }
}

.table-box {
  .table-box-handle {
    margin-bottom: 20px;
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;

  // .ant-pagination-options {
  //   float: left;
  // }

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    border: 1px solid #d9d9d9;
    width: 60px;
  }
}
</style>


